import React, {useState} from 'react';
import {
    CardNumberElement,
    CardExpiryElement,
    CardCVCElement,
    injectStripe
} from 'react-stripe-elements';   
import axios from 'axios';
import firebase from 'firebase/app';

import { Spinner, Callout, Card, Button } from "@blueprintjs/core";


function StripeCheckoutForm({auth, developers, stripe, cost, tokensBought}) {

    const [ showLoading, setShowLoading ] = useState(false)
    const [ showPaid, setShowPaid ] = useState(false)
    const [ showPayButton, setShowPayButton ] = useState(true)

    // console.log(cost * 100)
    console.log(developers)
    console.log(cost)
    console.log(tokensBought)

    const handleSubmit = async event => {
        event.preventDefault()
        setShowLoading(true)
        setShowPayButton(false)

        var amt = cost * 100
    
        const { token } = await stripe.createToken()
    
        axios.post('https://boundserver.herokuapp.com/stripe/charge', {
          amount: amt,
          source: token.id,
          receipt_email: auth.email
        })

        //update this below
        firebase.firestore()
        .collection('developers')
        .doc(developers[0].id)
        .update({
            tokens: firebase.firestore.FieldValue.increment(tokensBought),
        }).then(
        setShowLoading(false),
        setShowPaid(true)
        )
        .catch(function (error) {
            console.error('Error adding document: ', error);
        });
    
      }

    return (
    <div 
    className="checkout-form"
    style={{
        textAlign: 'left',
        marginTop: 20
    }}  
    >
      {/* <p>Amount: {amount}</p> */}
      <form 
        onSubmit={handleSubmit}
      >
          <label>
          Card details
          <Card
          style={{
            padding: 10,
            marginTop: 5,
            marginBottom: 5, 
            
          }}
          >
            <CardNumberElement />
          </Card>
          </label>
          <label>
          Expiration date
          <Card
          style={{
            padding: 10,
            marginBottom: 5, 
            marginTop: 5,
          }}
          >
            <CardExpiryElement />
          </Card>
          </label>
          <label>
          CVC
          <Card
          style={{
            padding: 10,
            marginBottom: 5, 
            marginTop: 5,
          }}
          >
            <CardCVCElement />
          </Card>
          </label>
          {showPayButton ? 
          <Button 
          type="submit" 
          className="order-button"
          style={{
            marginTop: 10
          }}
          intent="primary"
          >
          Pay
          </Button>
          : null}
          {showLoading ? 
          <div
          style={{
            marginTop: 10
          }}>
            <Spinner
            intent="primary"
            />
          </div>
          :
          null
          }
          {showPaid ? 
          <div>
            <Callout
            intent="success"
            >
              Paid
            </Callout>
          </div>
          :
          null
          }
      </form>
      </div>
    )
}

export default injectStripe(StripeCheckoutForm)
